import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Premium Volumes', '✅ 5 Bonus Kits'], ['✅ 50+ Choreography Drills', '✅ 12-Week Class Programs'], ['✅ Done-For-You Class Plans', '✅ 100% Printable Resources']];
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/hLhmRA6N6XGh5xwVFAnpgr/ChatGPT_Image_5_sept_2026,_08_49_39_p.m..png';
export function Hero() {
  return <>
      <section className="w-full bg-sky px-4 py-4 text-ink sm:py-6" data-id="element-107" data-mp="128yzkcr9hvyn">
        <div className="mx-auto max-w-5xl text-center" data-id="element-108" data-mp="xa4ipgcuuhh6">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex rounded-full border border-sky-line bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-teal" data-id="element-109" data-mp="x8jmznet0shq">
            🏃 The #1 System for Step Instructors
          </motion.span>
          
          
          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.16
        }} className="mx-auto mt-3 max-w-md text-sm leading-snug text-slate sm:text-base" data-id="element-110" data-mp="3j7zhzqi0g6kd">
            Ready-to-teach class plans, step sequences, choreography drills, and printable resources for professional
            step instructors.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-5 max-w-3xl text-center" data-id="element-111" data-mp="30fybq32wpe0x">
            <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-teal sm:text-xs" data-id="element-112" data-mp="2vjpxqt0g3qvc">
              📦 Everything You Get Instantly
            </p>
            <div className="mt-1.5 space-y-0.5 text-[11px] font-medium text-slate sm:text-xs" data-id="element-113" data-mp="2lkike5tpnw88">
              {benefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap justify-center gap-x-4 gap-y-0.5" data-id="element-114" data-mp="s2b7vyavsj55">
                  {row.map(benefit => <span key={benefit} data-id="element-115" data-mp="naji3pzjuhg2">{benefit}</span>)}
                </p>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-5 max-w-3xl" data-id="element-116" data-mp="ichyn3y7og42">
            <img src={mockupUrl} alt="Step Class Ready complete system — six printable volumes and digital drill bank" className="mx-auto block h-auto w-full max-w-2xl rounded-3xl object-contain shadow-elevated" data-id="element-117" data-mp="161az9dps3c50" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-5" data-id="element-118" data-mp="x0l5efk2vvtx">
            <CTAButton href="#complete-package" pulse size="large" data-id="element-119" data-mp="3htpyjt6msmmz">
              Get Instant Access
            </CTAButton>
            <p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-120" data-mp="21aej5hv4snb5">
              📄 High-Quality PDF <span className="mx-1" data-id="element-121" data-mp="269r7k71ni2fu">·</span> 🖨️ Printable Resources <span className="mx-1" data-id="element-122" data-mp="26867y30hbtb4">·</span>{' '}
              ⚡ Instant Download <span className="mx-1" data-id="element-123" data-mp="2b2ag2plhe7ds">·</span> 🔒 Secure Payment <span className="mx-1" data-id="element-124" data-mp="2g02jafrktfxa">·</span> 🛡️
              7-Day Guarantee
            </p>
          </motion.div>
        </div>
      </section>
      <section className="border-y border-sky-line bg-surface px-4 py-5 text-ink" data-id="element-125" data-mp="2kxc6rpvenhih">
        <div className="mx-auto max-w-3xl text-center" data-id="element-126" data-mp="2p1k060ct5ln1">
          <p className="text-sm font-bold sm:text-base" data-id="element-127" data-mp="2tzlfca7450t8">
            🚀 Launch offer active — Price increases when the timer hits zero
          </p>
          <div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-green-soft" data-id="element-128" data-mp="unrd141n9xwk">
            <div className="h-full w-[68%] rounded-full bg-green" data-id="element-129" data-mp="zmc2c8fcyx68" />
          </div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-130" data-mp="4akz14d7suim">68% of launch spots already claimed</p>
        </div>
      </section>
    </>;
}